export const API_BASE = "https://apiv2.onedose.io";
export const CHECKOUT_BASE = "https://shop.onedose.io";
// export const CHECKOUT_BASE = "https://pps.onedose.io";
// export const API_BASE = 'https://apistage.onedose.io';